<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
         x="0px" y="0px"
         viewBox="0 0 32 32" xml:space="preserve"
         :style="`fill: ${iconColor};`"
         :width="width"
         :height="height">
    <path d="M77.71,49V62.17a3.58,3.58,0,0,1-2.19,3.23l-3.14,1.26a2.62,2.62,0,0,1-3.67-2.49V49a1.67,1.67,0,0,0-.2-.57L58.25,35.2a2.42,2.42,0,0,1,2-4h26a2.42,2.42,0,0,1,2,4L77.9,48.39A1.66,1.66,0,0,0,77.71,49Z"
          transform="translate(-57.65 -31.17)"/>
    </svg>
</template>

<script>
    export default {
        name: "FilterFullIcon",
        props: {
            width: {
                type: [Number, String],
                default: 10
            },
            height: {
                type: [Number, String],
                default: 16
            },
            iconColor: {
                type: String,
                default: '#211f20'
            }
        }
    }
</script>

<style scoped>

</style>